import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'


const initialState = {
  cultivationData: {
    status: "idle",
    data: [],
    order: [],
    cultivationModels: [],
    crops: [],
    error: {},
  },
}

export const fetchData = createAsyncThunk('report', async (data) => {
    const {token} = data
    const axios = require("axios")
    const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const url = `/api/v0/data/cultivation/YILI` 

      const response = await axios.get(url, 
                 { headers })
      return response.data
})

const cultivationModelSlice = createSlice({
  name: 'models',
  initialState: initialState,
  reducers: {
  },
  extraReducers: {
    [fetchData.pending.type]:(state, action) => {
      state.cultivationData = {
        status: "loading",
        data: [],
        cultivationModels: [],
        crops: [],
        order: [],
        error: {},
      }
    },
    [fetchData.fulfilled.type]:(state, action) => {
      state.cultivationData = {
        status: "idle",
        data: action.payload.Data,
        order: action.payload.Order,
        cultivationModels: action.payload.CultivationModels,
        crops: action.payload.Crops,
        error: {},
      }
    },
    [fetchData.rejected.type]:(state, action) => {
      state.cultivationData = {
        status: "idle",
        data: [],
        order: [],
        cultivationModels: [],
        crops: [],
        error: "unauthorized",
      }
    },
  }
})

export default cultivationModelSlice.reducer
